module.exports = __webpack_public_path__ + "static/media/Hudson-falsterbo-miljo-2021.f1f0316d.jpg";